import { Injector, ApplicationRef, Component, OnInit, ComponentFactoryResolver, ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { timer } from "rxjs";
import { DashboardMultiStationService } from "../dashboard-multistation.service";
import { MsTodaysSnapshotComponent } from "../ms-todays-snapshot/ms-todays-snapshot.component";
import { MsBlockedListAttemptsComponent } from "../ms-blocked-list-attempts/ms-blocked-list-attempts.component";
import { MsDashboardUpdateRequest } from "../shared/MsDashboardUpdateRequest";
import { MsStationStatusComponent } from "../ms-station-status/ms-station-status.component";
import { MsTodaysVisiteesComponent } from "../ms-todays-visitees/ms-todays-visitees.component";
import { MsVisitorGraphComponent } from "../ms-visitor-graph/ms-visitor-graph.component";

@Component({
	selector: "caass-dashboard-multistation",
	templateUrl: "./dashboard-multistation.component.html",
	styleUrls: ["./dashboard-multistation.component.css"],
})
export class DashboardMultiStationComponent {
	constructor(private selectService: SchoolselectorService, private visitorService: DashboardMultiStationService) {}

	ngOnInit() {
		this.RefreshTimer = timer(this.RefreshSeconds * 1000, this.RefreshSeconds * 1000);
		this.Refresher = this.RefreshTimer.subscribe((val) => {
			this.onRefresh();
		});

		this.loadPreferences();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.Refresher.unsubscribe();

		this.UpdatePreferences();
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////

	subscription: any;

	SelectedSchool: any;

	LoadingFacility: any = true;
	FacilityID: any;
	lstFacility: any = [];

	LoadingPreference: any = true;
	Graph1OptionID: number = 1;
	Graph2OptionID: number = 1;

	Refresher: any;
	RefreshTimer: any;
	RefreshSeconds: any = 300; //5 Minutes

	@ViewChild(MsTodaysSnapshotComponent)
	snapshotRef: MsTodaysSnapshotComponent;

	@ViewChild(MsBlockedListAttemptsComponent)
	blockedRef: MsBlockedListAttemptsComponent;

	@ViewChild(MsStationStatusComponent)
	stationRef: MsStationStatusComponent;

	@ViewChild(MsTodaysVisiteesComponent)
	visiteeRef: MsTodaysVisiteesComponent;

	@ViewChild("Panel1")
	graphPanel1Ref: MsVisitorGraphComponent;

	@ViewChild("Panel2")
	graphPanel2Ref: MsVisitorGraphComponent;

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;

		if (this.SelectedSchool == undefined) {
			return;
		}

		var result = this.visitorService.FacilitySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				if (this.lstFacility.length > 0) {
					this.FacilityID = this.lstFacility[0].FacilityID;
				}

				this.LoadingFacility = false;
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadPreferences() {
		this.LoadingPreference = true;

		var result = this.visitorService.DashboardPreferenceSelect();
		result.subscribe(
			(response: any) => {
				this.Graph1OptionID = response.Graph1OptionID == undefined ? 1 : response.Graph1OptionID;
				this.Graph2OptionID = response.Graph2OptionID == undefined ? 1 : response.Graph2OptionID;

				this.LoadingPreference = false;
			},
			(error) => {
				this.LoadingPreference = false;
			}
		);
	}

	UpdatePreferences() {
		if (this.graphPanel1Ref != undefined || this.graphPanel2Ref == undefined) {
			return;
		}

		try {
			var parms: MsDashboardUpdateRequest = {
				Graph1OptionID: this.graphPanel1Ref.Option.ID,
				Graph2OptionID: this.graphPanel2Ref.Option.ID,
			};

			var result = this.visitorService.DashboardPreferenceUpdate(parms);
			result.subscribe(
				(response: any) => {},
				(error) => {}
			);
		} catch (e) {
			console.log(e);
		}
	}

	onRefresh() {
		this.snapshotRef.loadData();
		this.blockedRef.loadData();
		this.stationRef.loadData();
		this.visiteeRef.loadData();
		this.graphPanel1Ref.loadData();
		this.graphPanel2Ref.loadData();

		this.blockedRef.tableRef.ImageDict = new Map();
		this.blockedRef.tableRef.lstImageCalls = [];
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Events
	///////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadFacility();
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////
	IsLoading() {
		return this.LoadingFacility == true || this.LoadingPreference == true;
	}
	///////////////////////////////////////////
}
